import { isNullOrEmpty } from '../../utils/arrays';

export const isTeacherWithoutClass = (role, localClasses) => {
  return role === 'TEACHER' && isNullOrEmpty(localClasses);
};

export const isActiveButton = (subLink, pathname, isTeacherNoClass) => {
  return (
    subLink.matchLink === pathname ||
    (isTeacherNoClass &&
      pathname === '/' &&
      subLink.matchLink === '/giveFeedback') ||
    (subLink.matchLink === '/tools/rubrics' && pathname.startsWith('/tools/rubrics')) ||
    (subLink.matchLink === '/tools/commentbanks' && pathname.startsWith('/tools/commentbanks')) ||
    (subLink.matchLink === '/tools/successcriterias' && pathname.startsWith('/tools/successcriterias')) ||
    (subLink.matchLink === '/tools/shortanswers' && pathname.startsWith('/tools/shortanswers'))
  );
};
